import React from 'react';
import FlowTerminusLayout from '~/client/components/flow-terminus-layout/flow-terminus-layout';
import SelfServiceSummary from '~/client/components/self-service-summary/self-service-summary';
import type { BootCampShopConfirmation as Props } from './boot-camp-shop-confirmation.types';

const BootCampShopConfirmation: React.FC<Props> = ({ layout, summary }) => (
  <div className="boot-camp-shop-confirmation">
    <FlowTerminusLayout {...layout}>
      {summary ? <SelfServiceSummary {...summary} /> : null}
    </FlowTerminusLayout>
  </div>
);

export default BootCampShopConfirmation;
